import { render, staticRenderFns } from "./RoomBedManager.vue?vue&type=template&id=2fdc62f6&scoped=true"
import script from "./RoomBedManager.vue?vue&type=script&lang=js"
export * from "./RoomBedManager.vue?vue&type=script&lang=js"
import style0 from "./RoomBedManager.vue?vue&type=style&index=0&id=2fdc62f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdc62f6",
  null
  
)

export default component.exports